export default {corgi:{components:{rich_media:{error:{drop_one_at_a_time:'Please drop images one at a time.'}}}}};